<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel  >
      <action-bar>
        <b-navbar-nav>


          <action-button v-if="currentUser.role == 'Admin' && usersQuantity < appConf.status.maxUsers && tabIndex == 0"  @click="newUser" icon="new" bold :text="lang.button_NewUser" :title="lang.button_NewUser" :disabled="newuserButtonStatus"/>
          <action-button v-if="currentUser.role == 'Admin' && tabIndex == 1"  @click="newGroup" icon="new" bold :text="lang.button_NewGroup" :title="lang.button_NewGroup" :disabled="newgroupButtonStatus"/>
          <div  v-if="currentUser.role!='Admin'"></div>



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/Users/Views/Main/Middle/Content/Content"

  import { mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {

      tabIndex: 0,
      newuserButtonStatus: false,
      newgroupButtonStatus: false,


    }
  },
  computed: {
    ...mapGetters({

      appConf: 'appConf',
      usersQuantity: 'usersQuantity'
    }),
    currentUser(){
      return this.$store.getters.currentUser;
    },

  },
  created() {
    

  },
  methods: {
    switchButtons(index) {
      this.tabIndex = index;
    },
    newUser(){
      

      let _vue = this;

      let funcYes = function(e){

        let form = _vue.$store.getters.createUserForm;

        let groups = [];
        for (let i = 0, lei = _vue.$store.getters.permissionGroup.length; i < lei; i++) {
          groups.push(_vue.$store.getters.permissionGroup[i].groupId);
        }

        let obj = {
          userId: 0,
          firstName: form.FirstName,
          lastName: form.LastName,
          login: form.Login,
          password: form.Password,
          email: form.Email,
          isActive: form.IsActive,
          role: form.Role,
          groups: groups
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_createUser", obj)
        .then(function(result) {
          
          //console.log(result)
          if (result.status == "OK") {
            if (result.data != null) {

                let obj = {
                  text: _vue.lang.alert_success_CreateUser,
                  time: 10,
                  type: "success"
                }
                _vue.$store.dispatch("displayFooterAlert", obj)

                //reload table
                const reloadObj = {
                  status: true,
                  name: "UsersComponent"
                }
                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            } else {
                let obj = {
                  text: _vue.lang.alert_error_CreateUser + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj)
            }
          } else {
            let obj = {
                text: _vue.lang.alert_error_CreateUser + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)
          }
          




        })

      }

      var obj = {
        
        text: "",
        type: "new_user",
        buttons: 2,
        size: "lm",
        lang: this.lang.modal_CreateUser,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
    newGroup() {


      let _vue = this;

      let funcYes = function (e) {

        let form = _vue.$store.getters.createGroupForm;

        if (form.groupName == "") {

          let obj = {
            text: _vue.lang.alert_error_GroupName,
            time: 15,
            type: "danger"
          }
          _vue.$store.dispatch("displayFooterAlert", obj);

          return;
        }

        let obj = {
          groupName: form.groupName,
          permissions: form.permissions
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_createGroup", obj)
          .then(function (result) {

            //console.log(result)
            if (result.status == "OK") {
              if (result.data != null) {

                let obj = {
                  text: _vue.lang.alert_success_CreateGroup,
                  time: 10,
                  type: "success"
                }
                _vue.$store.dispatch("displayFooterAlert", obj)

                //reload table
                const reloadObj = {
                  status: true,
                  name: "GroupsComponent"
                }
                _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
              } else {
                let obj = {
                  text: _vue.lang.alert_error_CreateGroup + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj)
              }
            } else {
              let obj = {
                text: _vue.lang.alert_error_CreateGroup + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)
            }





          })

      }

      var obj = {

        text: "",
        type: "new_group",
        buttons: 2,
        size: "lm",
        lang: this.lang.modal_CreateGroup,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/Users/Views/Main/Middle/Middle.vue